module.exports = __webpack_public_path__ + "static/media/home.f2e23ce2.svg";